import {docsAsDataObject} from '../common'

function setCpAnswer(data) {

    const answers = {}
    
    const activities = Object.entries(data.activities).reduce( (acc,[activityId,activity]) => {
      activity.competencies.map(cp =>  acc[cp.id] ? acc[cp.id].push(activityId) : acc[cp.id] = [activityId] )
      return acc
    },{})

    Object.entries(data.cps).map(([id,cp]) =>  {
      console.log('cp')
      activities[id].map(activity => console.log(activity))

      
      cp.answer = 'tes2t'
      return cp
    })
      


    return data
  
  }
  

function formatAssessmentData(values) {
  // global repository
    return {   
        assessments: docsAsDataObject(values[0]),
        cps: docsAsDataObject(values[1]),
        activities: docsAsDataObject(values[2])
      }
  
  }

export default (values) => {

    let data = formatAssessmentData(values)
    //data = setCpAnswer(data)

    return data;
}



// WEBPACK FOOTER //
// ./src/assessments/utils/jfc-trial/format-report.js